"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentService = void 0;
const service_1 = require("./service");
class AttachmentService extends service_1.Service {
    constructor(transport, auth) {
        super(transport, auth);
    }
    /**
     * Get the authenticated URL for an attachment (universal for Forum and QMS).
     * Useful for passing to image components in React Native (no Cookie header needed).
     * @param attachmentId Attachment ID
     * @param filename Filename (optional, but recommended for mime types)
     */
    getUrl(attachmentId, filename = 'file') {
        if (!this.auth.userId || !this.auth.loginKey) {
            throw new Error('Not logged in (no session credentials)');
        }
        return `https://4pda.to/forum/dl/post/${attachmentId}/${encodeURIComponent(filename)}` +
            `?member_id=${this.auth.userId}&pass_hash=${this.auth.loginKey}`;
    }
    /**
     * Resolve direct download URL via socket (`fa` / 24934).
     * Preferred for forum attachments (CDN link with token).
     */
    async getDownloadUrl(attachmentId) {
        const response = await this.transport.send('fa', [attachmentId]);
        this.checkError(response, 'fa');
        const url = response.data[0];
        if (typeof url !== 'string' || !url.trim()) {
            throw new Error('Empty attachment URL from fa');
        }
        return url.trim();
    }
    /**
     * Download attachment from QMS or Forum.
     * Uses HTTP fetch with query param authentication (React Native compatible).
     * @param attachmentId Attachment ID
     * @param filename Filename (required for URL generation)
     * @returns Promise<ArrayBuffer> File content
     */
    /**
     * Upload file via `fu` / `su` protocol.
     * @param qms Pass `true` for QMS destination (`fu` with trailing `1`).
     */
    async upload(fileData, fileName, options) {
        return this.uploadFile(fileData, fileName, options?.onProgress, options?.qms ?? false);
    }
    async download(attachmentId, filename = 'file') {
        const url = this.getUrl(attachmentId, filename);
        const headers = {
            'User-Agent': '4PDA/1.9.43 (Android)'
        };
        const response = await fetch(url, { headers });
        if (!response.ok) {
            throw new Error(`Failed to download attachment from ${url}: status ${response.status} ${response.statusText}`);
        }
        return response.arrayBuffer();
    }
}
exports.AttachmentService = AttachmentService;
